
class HXFormFieldDateTime extends HXFormField {

    /** @private */
    inputObjTime = null;
    /** @private */
    inputNameTime = null;

    constructor(inputName,formName) {
        super(inputName,formName);
        this.inputNameTime = this.inputName+"_time";
        // InutTimeObj:
        var obj = null;
        if (this.formName!==null && document.forms[this.formName]!==undefined) {
            obj = document.forms[this.formName].elements[this.inputNameTime]; //absichtlich kein JQuery -> getAttribute
        }
        if (obj===undefined || obj===null) { //z.B. HXFormFieldSignatur ist kein echtes Inputfeld
            obj = document.getElementsByName(this.inputNameTime)[0];  //absichtlich kein JQuery -> getAttribute
        }
        this.inputObjTime = obj;
    }

     /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            this.setValueTime(this.getValueTime()); //Inhalt pruefen und aufformatieren

            var value = '' + this.getValue();
            var valueTime = '' + this.getValueTime();
            var focusTimeField = false;


            //Datum Eingabeformat pruefen
            if (value !== '' && HXFormFieldUtils.getDateTextFormated(value) == null) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());

                //Zeit Eingabeformat pruefen
            } else if (valueTime !== '' && HXFormFieldUtils.getTimeTextFormated(valueTime, false, this.getIntervalTimeMinute()) === null) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
                focusTimeField = true; //Focus auf Time-Field

                //Datum und Zeit - nur eines darf nicht alleine befuellt sein
            } else if ((value === '' && valueTime !== '') || (value !== '' && valueTime === '')) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                if (value !== '' && valueTime === '') focusTimeField = true; //Focus auf Time-Field

            //Datum und Zeit - Pflichtfeld
            } else if (!this.getOptional() && (value === '' || valueTime === '')) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                if (value !== '' && valueTime === '') focusTimeField = true; //Focus auf Time-Field

                //Datum und Uhrzeit im Min/Max Range
            } else if (value !== '' && (this.getRangeDateTimeMinText()!=='' || this.getRangeDateTimeMaxText()!=='')) {
                var minDate = hx.text2datetime(this.getRangeDateTimeMinText()); //text2datetime() liefert '' wenn ungueltig
                var maxDate = hx.text2datetime(this.getRangeDateTimeMaxText()); //text2datetime() liefert '' wenn ungueltig

                var msg = hx.replace(this.formVars.dictDateRangeMinAndMax, "#fieldname#", this.getLabel());
                if (minDate==='') msg = hx.replace(this.formVars.dictDateRangeMax, "#fieldname#", this.getLabel());
                if (maxDate==='') msg = hx.replace(this.formVars.dictDateRangeMin, "#fieldname#", this.getLabel());
                msg = hx.replace(msg, "#von#", this.getRangeDateTimeMinText());
                msg = hx.replace(msg, "#bis#", this.getRangeDateTimeMaxText());

                var inputDateTime = hx.text2datetime(this.getValue()+' '+this.getValueTime());
                if ((minDate!=='' && inputDateTime<minDate) || (maxDate!=='' && inputDateTime>maxDate)) {
                    this.validationPassed = false;
                    this.validationMsg = msg;
                }
            }

            if (alertResult===true) {
                super._validateFieldAlert(true,(focusTimeField===true) ? this.inputObjTime : null);
            }
        }
        return this.validationPassed;
    }

    /**
     * Setzt Text ins Datumsfeld, wird autom. ins korrekte Format aufformatiert
     * @param {string} dateText z.B. '15.03.2023'
     */
    setValue(dateText) {
        var formated = HXFormFieldUtils.getDateTextFormated(dateText);
        if (formated!==null) dateText = formated;
        super.setValue(dateText);
    }

    /**
     * Setzt Text in Zeitfeld, wird autom. ins korrekte Format aufformatiert
     * @param {string} timeText z.B. '12:15''
     */
    setValueTime(timeText) {
        var formated = HXFormFieldUtils.getTimeTextFormated(timeText, false, this.getIntervalTimeMinute());
        if (formated!==null) timeText = formated;
        this.inputObjTime.value = timeText;
    }

    /**
     * Liefert Inhalt des Time-Feldes
     * @returns {string}
     */
    getValueTime() {
        return this.inputObjTime.value;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'datetime');
    }

    /**
     * Liefert das Minutenintervall zurueck, 0 ... kein intervall
     * @returns {int}
     */
    getIntervalTimeMinute() {
        return hx.cint(this.inputObj.getAttribute('data-hx-minute-interval'));
    }

   /**
     * @param {int} interval
     */
    setIntervalTimeMinute(interval) {
        this.inputObj.setAttribute('data-hx-minute-interval',hx.cint(interval));
    }

    /**
     * wird verwendet, wenn heutiges Datum oder Datum vom Kalender eingefuegt wird
     * und die Uhrzeit leer ist
     * oder wenn heutiges Datum mit n/t/j eingefuegt wird
     * @param {string} timeText, leerstring = now()
     */
    setDefaultTimeText(timeText) {
        if (timeText==null) timeText = '';
        this.inputObj.setAttribute('data-hx-valuetime_default',timeText);
    }

    /**
     * @returns {string}
     */
    getDefaultTimeText() {
        var timeText = this.inputObj.getAttribute('data-hx-valuetime_default');
        return timeText;
    }

    /**
     *
     * @param {string|null} minDate z.B. '01.01.2023', null fuer keine Grenze
     * @param {string|null} minTime z.B. '15:00'
     */
    setRangeDateTimeMinText(minDateText, minTimeText = null) {
        var dateTimeStr = null;
        if (minTimeText===null || minTimeText==='') minTimeText = '00:00';
        if (minDateText===null || minDateText===''){
            dateTimeStr='';
        }else{
            dateTimeStr = minDateText + ' ' + minTimeText;
            if (hx.text2datetime(dateTimeStr)==='') dateTimeStr = '';
        }
        this.inputObj.setAttribute('data-hx-rangemin-datetext', dateTimeStr);
    }

    /**
     *
     * @param {string|null} maxDate z.B. '01.01.2023', null fuer keine Grenze
     * @param {string|null} maxTime z.B. '15:00'
     */
    setRangeDateTimeMaxText(maxDateText, maxTimeText = null) {
        var dateTimeStr = null;
        if (maxTimeText===null || maxTimeText==='') maxTimeText = '00:00';
        if (maxDateText===null || maxDateText==='') {
            dateTimeStr='';
        }else{
            dateTimeStr = maxDateText + ' ' + maxTimeText;
            if (hx.text2datetime(dateTimeStr)==='')dateTimeStr = '';
        }
        this.inputObj.setAttribute('data-hx-rangemax-date', dateTimeStr);
    }

    /**
     * @return {string}
     */
    getRangeDateTimeMinText() {
        return this.inputObj.getAttribute('data-hx-rangemin-datetext');

    }


    /**
     @return {string}
     */
    getRangeDateTimeMaxText() {
        return this.inputObj.getAttribute('data-hx-rangemax-date');

    }

    /**
     * @param {string} position, above / under
     */
    setDatePickerPosition(position = "under") {
        if (position !== "under") position="above";
        this.inputObj.setAttribute('data-hx-datepicker-pos',position);
    }

    /**
     * @return {string} above | under
     */
    getDatePickerPosition() {
        return this.inputObj.getAttribute('data-hx-datepicker-pos');
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()) {
            //Datum Tastendruck
            this.inputObj.addEventListener("keydown", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                var result = HXFormFieldUtils.getDateTextKeyEventResult(this.getValue(), event, this.getDefaultTimeText());
                if (result.dateText!==null) {
                    this.setValue(result.dateText);
                    this.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
                }
                if (result.timeText!==null) {
                    this.setValueTime(result.timeText);
                    this.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
                }
                if (result.allowKey===false) event.preventDefault(); //Erscheinen ungueltiger Zeichen im Feld verhindern
                return result.allowKey;
            });
            //Datum Feld verlassen
            this.inputObj.addEventListener("blur", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            });

            //Time Tastendruck
            this.inputObjTime.addEventListener("keydown", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                var result = HXFormFieldUtils.getTimeTextKeyEventResult(this.getValueTime(), event, this.getIntervalTimeMinute(), false, this.getDefaultTimeText());
                if (result.timeText!==null) {
                    this.setValueTime(result.timeText);
                    this.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
                }
                if (result.allowKey===false) event.preventDefault(); //Erscheinen ungueltiger Zeichen im Feld verhindern
                return result.allowKey;
            });

            //Time Feld focus
            this.inputObjTime.addEventListener("focus", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.getFieldObj().dispatchEvent(new Event('focus'));  // Event focus auf inputObj ausloesen fuehrt zu Endlos-Aufrufkette!
            });

            //Time Feld verlassen
            this.inputObjTime.addEventListener("blur", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setValueTime(this.getValueTime()); //Inhalt pruefen und aufformatieren
                this.getFieldObj().dispatchEvent(new Event('blur'));  // Event blur auf inputObj ausloesen fuehrt zu Endlos-Aufrufkette!
            });

            //Kalender Icon anklicken
            document.getElementById(this.inputName+'_calendaricon').addEventListener("click", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                HXFormFieldDatePicker.init(this.inputName,this.formName,this.formVars,this.getFormFieldTypeName());
            });

            //Kalender Icon Tastendruck (Space oeffnet/schliesst Kalender)
            document.getElementById(this.inputName+'_calendaricon').addEventListener("keypress", (event) => {
                if (event.key===" ") {
                    HXFormFieldDatePicker.init(this.inputName,this.formName,this.formVars,this.getFormFieldTypeName());
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
}